import { Phone } from "lucide-react";
import { Facebook, Linkedin } from "lucide-react";

const TopBar = () => {
  return (
    <div className="bg-[#2c2c2c] text-white py-2">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center text-sm">
          <a href="tel:8197529288" className="flex items-center gap-2 hover:text-accent transition-colors">
            <Phone className="w-4 h-4" />
            <span>Appelez-nous: (819) 752-9288</span>
          </a>
          <div className="flex items-center gap-4">
            <span className="hidden sm:inline">Rejoignez notre communauté sur les réseaux sociaux!</span>
            <div className="flex gap-3">
              <a 
                href="https://www.facebook.com/agrorefrigeration/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-accent transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.linkedin.com/company/agro-r%C3%A9frig%C3%A9ration-inc/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-accent transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
